import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { AuthStatus } from "./auth";

export const accountScope = (session?: AuthStatus) => JSON.stringify([session?.appId || "", session?.user?.id || null,
  session?.user?.products?.sales ?? null, session?.user?.products?.video ?? null, session?.user?.products?.video_read_only ?? null]);

/** Late writes keep their server receipt, not the departed editor's UI effects. */
export function useCurrentAccountCallback() {
  const cache = useQueryClient();
  const scope = accountScope(cache.getQueryData<AuthStatus>(["auth-status"]));
  const active = useRef(true);
  useEffect(() => { active.current = true; return () => { active.current = false; }; }, []);
  return () => active.current && scope === accountScope(cache.getQueryData<AuthStatus>(["auth-status"]));
}
